import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const PastDueReminder = ({ workshops, onNavigate }) => {
  const pastDueWorkshops = workshops.filter(ws => {
    if (ws.status !== 'scheduled' || ws.attendance_submitted) return false;
    const workshopDate = new Date(ws.delivery_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return workshopDate < today;
  });

  if (pastDueWorkshops.length === 0) return null;

  return (
    <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-6 rounded-r-lg" data-testid="past-due-reminder">
      <div className="flex items-start">
        <AlertTriangle className="text-amber-500 flex-shrink-0 mt-0.5" size={20} />
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-semibold text-amber-800">
            Attendance Data Required
          </h3>
          <p className="text-sm text-amber-700 mt-1">
            You have <span className="font-bold">{pastDueWorkshops.length}</span> past workshop{pastDueWorkshops.length > 1 ? 's' : ''} that need{pastDueWorkshops.length === 1 ? 's' : ''} attendance data.
            Microsoft tracks training impact through attendance records - please submit the data to maintain your portal access.
          </p>
          <button
            onClick={() => onNavigate('my-workshops')}
            className="mt-2 text-sm font-medium text-amber-800 hover:text-amber-900 underline"
          >
            Submit Attendance Data →
          </button>
        </div>
      </div>
    </div>
  );
};
